<template>
  <div class="time-sheet-histories">
    <TimeSheetHistoryRecord
      v-for="(historyRecord, index) in timeSheetHistories"
      :key="historyRecord.id"
      :history-record="historyRecord"
      :num="timeSheetHistories.length - index"
    />
  </div>
</template>

<script>
import TimeSheetHistoryRecord from './TimeSheetHistoryRecord';
export default {
  name: 'TimeSheetHistoryList',
  components: { TimeSheetHistoryRecord },
  computed: {
    timeSheetHistories() {
      return this.$store.state.timeSheetsState.timeSheetDetailsState.timeSheetHistories;
    }
  }
};
</script>
